import React, { useState } from 'react';
import { Button, CircularProgress, Snackbar, Typography, Grid, Box } from '@mui/material';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';




const API_URL = process.env.REACT_APP_API_URL;

const CancelSessionAcceptedRequestsButton = ({ requestId, userId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);


  const handleCancelSession = async () => {
    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      // Send request_id and user_id to the backend API
      const response = await axios.post(`${API_URL}/cancel-session-accepted-requests/`, {
        request_id: requestId,
        user_id: userId,
      }, {
        withCredentials: true,
      });

      if (response.status === 200) {
        setSuccessMessage(response.data.message);
        setOpenSnackbar(true);
      }
    } catch (err) {
      console.error(err);
      setError('Failed to cancel session. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div>
       <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        // mt: 2,
        width: '100%',
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} sm="auto">
      <Button
        variant="contained"
        color="error"
        // onClick={handleCancelSession}
        onClick={() => setOpenCancelDialog(true)}
        disabled={loading}
        startIcon={loading && <CircularProgress size={24} />}
        sx={{mt:3, letterSpacing: 4}}
      >
        {loading ? 'Canceling...' : 'Cancel Session'}
      </Button></Grid>

      <Dialog
  open={openCancelDialog}
  onClose={() => setOpenCancelDialog(false)}
  PaperProps={{
    sx: {
      borderRadius: "16px",
      padding: 2,
      backgroundColor: "#1e1e1e",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
      maxWidth: 420,
      mx: 'auto',
    },
  }}
>
  <DialogTitle
    sx={{
      fontWeight: 'bold',
      fontSize: '1.5rem',
      textAlign: 'center',
      color: '#ff5f5f',
      pb: 1,
    }}
  >
    Cancel Session?
  </DialogTitle>

  <DialogContent sx={{ textAlign: 'center', px: 3 }}>
    <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
      Are you sure you want to cancel this session? This action cannot be undone.
    </Typography>
  </DialogContent>

  <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
    <Button
      onClick={() => setOpenCancelDialog(false)}
      sx={{
        borderRadius: '25px',
        padding: '0.6rem 1.5rem',
        backgroundColor: '#333',
        color: '#ddd',
        textTransform: 'none',
        "&:hover": {
          backgroundColor: '#444',
        },
      }}
    >
      Go Back
    </Button>

    <Button
      onClick={() => {
        handleCancelSession(); // actual cancel logic
        setOpenCancelDialog(false);
      }}
      variant="contained"
      sx={{
        borderRadius: '25px',
        padding: '0.6rem 1.8rem',
        textTransform: 'none',
        background: "linear-gradient(45deg, #ff4d4d, #d93636)",
        fontWeight: 'bold',
        letterSpacing: 1,
        color: '#fff',
        "&:hover": {
          transform: 'scale(1.05)',
          boxShadow: '0 8px 20px rgba(255, 77, 77, 0.4)',
        },
      }}
    >
      Confirm Cancel
    </Button>
  </DialogActions>
</Dialog></Grid>


      {error && <div style={{ color: 'red', marginTop: '10px', letterSpacing: 4 }}>{error}</div>}

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={successMessage}
        sx={{letterSpacing: 4}}
      />
      </Box>
    </div>
  );
};

export default CancelSessionAcceptedRequestsButton;
